var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.815 7.53299C15.7668 7.52496 15.7106 7.52496 15.6625 7.53299C14.5546 7.49285 13.6716 6.5857 13.6716 5.46181C13.6716 4.31383 14.5948 3.39062 15.7427 3.39062C16.8907 3.39062 17.8139 4.32185 17.8139 5.46181C17.8059 6.5857 16.9228 7.49285 15.815 7.53299Z",
    stroke: "currentColor",
    strokeWidth: 1.31364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9881 13.3773C16.0879 13.5619 17.3002 13.3692 18.1511 12.7993C19.283 12.0446 19.283 10.8083 18.1511 10.0537C17.2921 9.48376 16.0639 9.29108 14.9641 9.48375",
    stroke: "currentColor",
    strokeWidth: 1.31364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1575 7.53299C6.20567 7.52496 6.26186 7.52496 6.31003 7.53299C7.41787 7.49285 8.30093 6.5857 8.30093 5.46181C8.30093 4.31383 7.37773 3.39062 6.22975 3.39062C5.08177 3.39062 4.15857 4.32185 4.15857 5.46181C4.1666 6.5857 5.04966 7.49285 6.1575 7.53299Z",
    stroke: "currentColor",
    strokeWidth: 1.31364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98438 13.3773C5.88457 13.5619 4.67237 13.3692 3.82142 12.7993C2.68949 12.0446 2.68949 10.8083 3.82142 10.0537C4.68039 9.48376 5.90865 9.29108 7.00846 9.48375",
    stroke: "currentColor",
    strokeWidth: 1.31364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9983 13.5298C10.9501 13.5218 10.8939 13.5218 10.8458 13.5298C9.73792 13.4897 8.85486 12.5825 8.85486 11.4586C8.85486 10.3107 9.77806 9.38745 10.926 9.38745C12.074 9.38745 12.9972 10.3187 12.9972 11.4586C12.9892 12.5825 12.1061 13.4977 10.9983 13.5298Z",
    stroke: "currentColor",
    strokeWidth: 1.31364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66218 16.0586C7.53025 16.8132 7.53025 18.0495 8.66218 18.8041C9.94663 19.6631 12.0499 19.6631 13.3344 18.8041C14.4663 18.0495 14.4663 16.8132 13.3344 16.0586C12.0579 15.2077 9.94663 15.2077 8.66218 16.0586Z",
    stroke: "currentColor",
    strokeWidth: 1.31364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.298a4374.svg";
export { ForwardRef as ReactComponent };